import { Accordion, AccordionItem } from "@heroui/accordion";
import { useEffect, useMemo, useRef, useState } from "react";
import { FormProvider, useForm, useWatch } from "react-hook-form";
import toast from "react-hot-toast";
import { useParams } from "react-router";
import { GetLocalStorage } from "../../../../../../utils/functions/GetLocalStorage.js";
import {
  useCalculateMainScoreMutation,
  useCrossReviewSummaryMutation,
  useGetAppraisalReviewDetailsQuery,
  useGetMainSelfReviewByAppraisalTypeQuery,
  useGetMainSelfReviewQuery,
  useSaveCrossReviewMutation,
} from "../../../../../api/employeeApi";
import DashboardStyle from "../../../../../dashboard/Styles/Dashboard.module.css";
import { ActionButtons } from "../../../../../global/components/Buttons/buttons";
import bull from "../../../../assets/bull.png";
import flag from "../../../../assets/finish-FLAG.png";
import person from "../../../../assets/personAppraisal.png";
import { FormTextArea } from "../../../../Components/Forms/InputTemplate";
import PageStyle from "../../../../Components/Layout/PageLayout";
import { MetaData } from "../../SelfAppraisal/data.jsx";
import { FormContent } from "./FormContent.jsx";
import { FormatDateTime } from "../../../../../../utils/functions/ResourceFunctions.js";
export const ViewCrossReview = () => {
  const { id, referenceId } = useParams();
  // const { data } = useGetMainSelfReviewQuery(referenceId);
  const user = GetLocalStorage();

  const { data } = useGetMainSelfReviewByAppraisalTypeQuery({
    appraiserId: user.staffId,
    referenceId,
    appraisalType: 4,
  });

  const { data: details } = useGetAppraisalReviewDetailsQuery(id);
  const employeeData = data?.responseObject?.employee;

  const formMethods = useForm({
    mode: "all",
    defaultValues: {
      MostDifficultElement: "",
      PerformanceOutcomeComment: "",
    },
  });
  const [kraId, setKraId] = useState(0);
  const [objIndex, setObjIndex] = useState(-1);
  const [kraIndex, setKraIndex] = useState(-1);
  const watched = useWatch({ control: formMethods.control });
  const [score, setScore] = useState({
    actualValue: 0,
    targetValue: 0,
    weight: 0,
  });

  const [item, setItem] = useState();
  const currentActualValue =
    objIndex !== undefined && kraIndex !== undefined
      ? watched[`KRAs_${objIndex}_${kraIndex}_actualScore`]
      : 0;

  useEffect(() => {
    if (item?.kraId && objIndex !== undefined && kraIndex !== undefined) {
      setScore({
        actualValue: parseFloat(currentActualValue) || 0,
        targetValue: item.targetValue,
        weight: item.weight,
      });
    }
  }, [item, kraIndex, objIndex, currentActualValue]);

  const [onSubmit, { isLoading }] = useCrossReviewSummaryMutation();

  const [onSave] = useSaveCrossReviewMutation();
  const [kra, setKra] = useState("");
  const crossReviewType = useMemo(
    () =>
      kra?.employeeReviewDetails?.find(
        (k) => k?.appraisalType === 4 && k?.kraId === kraId
      )?.crossReviewType,
    [kra, kraId]
  );

  const crossReviewTypeSummary = useMemo(
    () =>
      data?.responseObject?.objectives[0].kras[0].employeeReviewDetails?.find(
        (k) => (k?.appraisalType === 4 && k?.appraiserId === user?.staffId)
      )?.crossReviewType,
    [data, user]
  );
  const handleSave = async () => {
    try {
      if (objIndex === -1 || kraIndex === -1) {
        toast.error("KRA not found");
        return;
      }
      const kraKey = `${objIndex}_${kraIndex}`;
      const kraActualScore =
        formMethods.getValues(`KRAs_${kraKey}_actualScore`) || 0;
      const comment = formMethods.getValues(`KRAs_${kraKey}_comments`) || "";
      const artifacts = formMethods.getValues(`KRAs_${kraKey}_artifacts`);
      const formData = new FormData();
      formData.append("ReferenceId", referenceId);
      formData.append("KRAId", kraId);
      // formData.append("AppraiseeId", employeeData?.id);
      formData.append("AppraiserId", user?.staffId);
      formData.append("Score", parseFloat(kraActualScore));
      formData.append("Comment", comment);
      formData.append("CrossReviewType", crossReviewType);
      if (artifacts && artifacts.length > 0) {
        artifacts.forEach((artifact, index) => {
          formData.append(`Artifacts`, artifact.file);
        });
      }
      const res = await onSave(formData).unwrap();
      if (res.successful) {
        toast.success(res?.statusMessage || "KRA saved successfully");
      }
    } catch (err) {
      toast.error("Save failed: " + (err.data?.statusMessage || err.message));
    }
  };
  const submit = async () => {
    const summaryComment = formMethods.getValues(`summaryComment`);
    try {
      const formattedData = {
        referenceId: referenceId,
        appraiserId: Number.parseInt(user?.staffId) || 0,
        summaryComment: summaryComment || "",
        "crossReviewType": Number(crossReviewTypeSummary)
      };

      const response = await onSubmit(formattedData).unwrap();
      console.log("Submission successful", response);
      toast.success(response?.statusMessage || "Submission successful");
    } catch (err) {
      console.log("Submission failed", err);
      toast.error(
        "Submission failed: " + (err.data?.statusMessage || err.message)
      );
    }
  };
  const [kraPerformanceScores, setKraPerformanceScores] = useState({});
  const [onCalculateMainScore] = useCalculateMainScoreMutation();
  const debounceRefMain = useRef(null);
  useEffect(() => {
    if (!score.actualValue && !score.targetValue && !score.weight) return;
    if (!item?.kraId) return;

    if (debounceRefMain.current) clearTimeout(debounceRefMain.current);

    debounceRefMain.current = setTimeout(async () => {
      try {
        const res = await onCalculateMainScore({
          actualValue: score.actualValue,
          targetValue: score.targetValue,
          weight: score.weight,
        }).unwrap();

        if (res) {
          setKraPerformanceScores((prev) => ({
            ...prev,
            [item.kraId]: res.kraPerformanceScore,
          }));
        }
      } catch (err) {
        console.error("Error calculating main score:", err);
      }
    }, 500);

    return () => {
      if (debounceRefMain.current) clearTimeout(debounceRefMain.current);
    };
  }, [score, onCalculateMainScore, item?.kraId]);
  return (
    <div>
      <PageStyle
        hasBack={true}
        backURL={`/dashboard/employee/performance-appraisal/cross-review`}
        demoTitle={"Cross Review Details"}
        hasTopPageDemo
      >
        <FormProvider {...formMethods}>
          <form id="selfAssessmentForm">
            <div className="flex items-center justify-between mb-4">
              <div className="w-[30px]" />
              <div>
                <p className="text-[#00AB09]">
                  {/* Total Actual Score: {totalActualScore} */}
                </p>
              </div>
            </div>
            <div className="mb-4"></div>
            <Accordion
              aria-label={`Accordion 1`}
              selectionMode="single"
              defaultExpandedKeys={["1"]}
              titleWrapper="shadow-md rounded-md border border-gray-200"
            >
              <AccordionItem
                title={
                  <div className="flex items-center gap-5 px-5">
                    <img src={person || "/placeholder.svg"} alt="" />{" "}
                    <span className="text-[#305F32] font-[600]">
                      EMPLOYEE PROFILE SUMMARY
                    </span>
                  </div>
                }
                className="shadow-md rounded-md border border-gray-200 py-3 mb-2"
              >
                <MetaData data={employeeData} />
              </AccordionItem>
            </Accordion>

            {data?.responseObject?.objectives?.map((item, index) => (
              <Accordion
                aria-label={`Accordion ${index + 1}`}
                key={index + 1}
                selectionMode="single"
                titleWrapper="shadow-md rounded-md border border-gray-200"
              >
                <AccordionItem
                  key={index + 1}
                  title={
                    <div className="flex items-center justify-between px-5">
                      <div className="flex items-center gap-5">
                        <img src={flag || "/placeholder.svg"} alt="" />
                        <span className="text-[#4B664C] font-[600]">
                          OBJECTIVE: {item?.objectiveTitle}
                        </span>
                      </div>
                      <div>
                        <span className="text-[#4B664C] font-[600]">
                          Weight: {item?.objectiveWeight}%
                        </span>
                      </div>
                      <div className="w-10" />
                    </div>
                  }
                  className="shadow-md rounded-md border border-gray-200 py-3 mb-2"
                >
                  <div>
                    {item.krAs.map((items, kraIndex) => (
                      <Accordion
                        key={kraIndex}
                        aria-label={`Accordion ${kraIndex + 1}`}
                        selectionMode="single"
                        defaultExpandedKeys={["1"]}
                        titleWrapper="shadow-md rounded-md border border-gray-200"
                        onClick={() => {
                          setKraId(items.kraId);
                          setKra(items);
                          setObjIndex(index);
                          setKraIndex(kraIndex);
                          setItem(items);
                        }}
                      >
                        <AccordionItem
                          key={kraIndex}
                          title={
                            <div className="flex items-center gap-5 px-5">
                              <img src={bull || "/placeholder.svg"} alt="" />
                              <span className="text-[#4B664C] font-[600]">
                                KRA: {items?.kraTitle}
                              </span>
                            </div>
                          }
                          className="shadow-md rounded-md border border-gray-200 py-3 mb-2"
                        >
                          <div>
                            <div className="flex items-center justify-between px-5">
                              <div />
                              <div>
                                <p className="text-[#4B664C] font-[600]">
                                  isAutogenerated:{" "}
                                  {items.isAutoGenerated ? "Yes" : "No"}
                                </p>
                              </div>
                            </div>
                            <div
                              key={kraIndex + 1}
                              className="flex items-center gap-5 py-2 px-5"
                              style={{
                                display: "grid",
                                gridTemplateColumns: "180px 1fr",
                                alignItems: "center",
                                gap: "16px",
                              }}
                            >
                              <h2 className="text-[#305F32] font-[600]">
                                Title: {items.kraTitle}
                              </h2>
                              <h4 className="text-[#305F32] font-[500]">
                                Description: {items.kraDescription}
                              </h4>
                              <h2 className="text-[#305F32] font-[600]">
                                Target: {items.targetValue}
                              </h2>
                              <h4 className="text-[#00AB09] font-[500]">
                                Score:
                                {kraPerformanceScores[items.kraId] ||
                                  items?.employeeReviewDetails?.filter(
                                    (item) => item.appraisalType === 4
                                  )?.[0]?.kraScore || "Not scored yet"}
                              </h4>
                              <h4 className="text-[#305F32] font-[500]">
                                Measurement Type: {items.measurementType}
                              </h4>
                              <h4 className="text-[#305F32] font-[500]">
                                Period Start Date:{" "}
                                {FormatDateTime(
                                  items.periodStartDate,
                                  "DD/MM/YYYY"
                                )}
                              </h4>
                              <h4 className="text-[#305F32] font-[500]">
                                Period End Date:{" "}
                                {FormatDateTime(
                                  items.periodEndDate,
                                  "DD/MM/YYYY"
                                )}
                              </h4>
                              <h4 className="text-[#305F32] font-[500]">
                                Next Due Date:{" "}
                                {FormatDateTime(items.slaDueDate, "DD/MM/YYYY")}
                              </h4>
                              <h4 className="text-[#305F32] font-[500]">
                                SLA Due Date:{" "}
                                {FormatDateTime(
                                  items.slaDueDate,
                                  "DD/MM/YYYY"
                                )}
                              </h4>
                            </div>
                          </div>
                          <FormContent
                            id={items.kraId}
                            objIndex={index}
                            kraIndex={kraIndex}
                            items={items}
                            formMethods={formMethods}
                            defaultValues={
                              items?.employeeReviewDetails?.filter(
                                (item) => item.appraisalType === 4
                              )?.[0]
                            }
                          />

                          <div
                            style={{ marginTop: "1rem" }}
                            className={`flex justify-end mr-5`}
                          >
                            <ActionButtons
                              width={"auto"}
                              type={"button"}
                              onClick={handleSave}
                              className={DashboardStyle?.button_cage_weight}
                              bg="var(--primary-color)"
                            >
                              {isLoading ? "Saving..." : "Save"}
                            </ActionButtons>
                          </div>
                        </AccordionItem>
                      </Accordion>
                    ))}
                  </div>
                </AccordionItem>
              </Accordion>
            ))}
            <div className="mt-8 p-4 bg-gray-50 rounded-lg">
              <h3 className="text-lg font-semibold text-[#305F32] mb-4">
                General Assessment
              </h3>
              <div className="space-y-4">
                <FormTextArea
                  className="h-[150px]"
                  title={"Performance Outcome Comment"}
                  camelCase={"summaryComment"}
                  placeholder="Enter your overall performance comments"
                  type="text"
                  textAreaClassName=""
                  isRequired={true}
                />
              </div>
            </div>
            <div
              style={{ marginTop: "1rem" }}
              className={`flex justify-end mr-5`}
            >
              <ActionButtons
                width={"auto"}
                type={"button"}
                onClick={submit}
                className={DashboardStyle?.button_cage_weight}
                bg="var(--primary-color)"
                disabled={isLoading}
              >
                {isLoading ? "Submitting..." : "Submit"}
              </ActionButtons>
            </div>
          </form>
        </FormProvider>
      </PageStyle>
    </div>
  );
};
